module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/maruhachi-322bafb255c00fe97bc6d2d1929192f1.png";